import { render } from "./Signup.vue?vue&type=template&id=688af589"
import script from "./Signup.vue?vue&type=script&lang=js"
export * from "./Signup.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rogerkirton/Documents/Development/Soca Islands Repos/app-soca-islands/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__